import { PointAPI } from '../../../api/schematicmap/PointAPI';

export class PointsCommand {
    get(edition, pointType, pathIds, successCallback, errorCallback) {
        let apiResult = undefined;
        if(0 === pointType) {
            apiResult = PointAPI.getMapPoints(edition, pathIds);
        }
        else {
            apiResult = PointAPI.getStops(edition, pathIds);
        }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getAllMapPoints(edition, successCallback, errorCallback) {
        let apiResult = PointAPI.getAllMapPoints(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
